// utils
import _ from 'lodash';

/**
 * represents an instance of pad editor
 * @class PadEditor
 */
export default class PadEditor {
  /**
   * @param {object} state - pad editor element state
   * @returns {this}
   */
  constructor(state) {
    if (new.target === PadEditor) {
      throw new Error('PadEditor is an abstract class.');
    }

    this._state = _.cloneDeep(state);
    this._currentData = _.cloneDeep(state.data.current);
    this._screenData = _.cloneDeep(state.data.screen);
    this._loadedData = _.cloneDeep(state.data.loaded);
  }

  /**
   * get state.
   * @returns {object} the pad editor element state
   */
  getState() {
    this._state.data.current = this._currentData;
    this._state.data.loaded = this._loadedData;
    this._state.data.screen = this._screenData;
    return this._state;
  }

  /**
   * change loading state.
   * * @param {Boolean} Boolean - state of loading.
   * @returns {this}
   * @default Boolean is true
   */
  setLoading(paramBoolean = true) {
    this._state.loading = paramBoolean;

    return this;
  }

  setErrors(errors = []) {
    this._state.errors = errors;

    return this;
  }
}
